<template>
  <form-post
    ref="formPost"
    :params="params"
    route="/admin/site-admin-session/log-viewer"
  ></form-post>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: 'Log Viewer'
    }
  },
  data: () => ({
    csrfToken: null,
  }),
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await this.$nextTick()
      this.$store.dispatch('loading/active')
      this.$store.dispatch('loading/progress')
      await this.$helper.delay(1)
      this.$refs.formPost.submit()
    },
  },
  computed: {
    tokenStore() {
      return this.$store.getters['token/tokenStore']
    },
    params() {
      return {
        fingerprint: this.$fingerprint.get(),
        token: this.tokenStore.get(),
      }
    },
  }
}
</script>

<style lang="sass" type="text/sass" scoped></style>
